module.exports = __webpack_public_path__ + "static/media/Marvel.8af64d82.png";